var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolicewoman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 494.944 494.944",
    style: {
      enableBackground: "new 0 0 494.944 494.944"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M164.323,249.688c-10.656-13.032-15.328-92.04-16.656-93.72c-1.344-1.688,4.864-4.984,4.864-4.984 l67.384-40.168l12.216,96.056l-28.04,20.52"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M330.611,249.688c10.672-13.032,15.328-92.04,16.672-93.72c1.328-1.688-20.016-33.152-20.016-33.152 l-59.912,18.48l-4.536,65.568l28.032,20.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.475,
    y: 398.944,
    style: {
      fill: "#F9BDA0"
    },
    width: 384,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.475,
    y: 206.944,
    style: {
      fill: "#F9BDA0"
    },
    width: 96,
    height: 200
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAA78C"
    },
    points: "295.475,304.552 295.475,206.944 200.451,206.944 248.683,343.584 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M322.435,126.528c0,72.24-36.624,137.616-74.944,137.616s-74.96-65.376-74.96-137.616 s36.64-84.288,74.96-84.288S322.435,54.288,322.435,126.528z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M247.491,42.24c38.32,0,74.944,12.048,74.944,84.288s-36.624,137.616-74.944,137.616"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "203.203,310.728 47.011,358.8 55.011,493.616 243.995,445.768  "
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FCCCB9"
    },
    points: "47.011,358.8 55.011,493.616 243.995,445.768 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "291.763,310.728 447.939,358.8 439.939,493.616 250.939,445.768 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#EAA78C"
    },
    points: "447.939,358.8 439.939,493.616 250.939,445.768 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M257.907,37.48c0,0-70.2,54.24,89.376,118.488c0,0,3.608-71.6-22.456-102.416 c-26.08-30.8-66.44-27-66.44-27L257.907,37.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M282.859,28.376c0,0-9.608,68.44-135.672,132.048c0,0-11.784-75.976,18.984-108.528 c30.76-32.552,85.92-27.144,85.92-27.144L282.859,28.376z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 55.475,
    y: 398.944,
    style: {
      fill: "#EA5807"
    },
    width: 384,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.475,
    y: 406.944,
    style: {
      fill: "#125389"
    },
    width: 384,
    height: 88
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2EA5C6"
    },
    points: "241.491,494.944 193.283,313.096 46.467,359.6 50.699,494.944 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2680B2"
    },
    points: "241.491,494.944 193.283,313.096 46.467,359.6 66.699,494.944 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F6899"
    },
    points: "241.491,494.944 193.283,313.096 46.467,359.6 98.699,494.944 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#125389"
    },
    points: "253.459,494.944 301.667,313.096 448.483,359.6 444.251,494.944 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1F6899"
    },
    points: "181.307,305.48 199.939,284.816 247.475,328.816 247.475,422.944 221.635,422.944  204.827,363.208 157.099,323.512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#125389"
    },
    points: "313.643,305.48 295.019,284.816 247.475,328.816 247.475,422.944 273.315,422.944  290.115,363.208 337.851,323.512 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#042635"
    },
    cx: 247.475,
    cy: 356.152,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#042635"
    },
    cx: 247.475,
    cy: 383.824,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#042635"
    },
    cx: 247.475,
    cy: 411.504,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#042635"
    },
    cx: 247.475,
    cy: 439.104,
    r: 5.336
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#042635"
    },
    cx: 247.475,
    cy: 466.784,
    r: 5.336
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A4554"
    },
    d: "M234.667,161.344c0,14.256-12.184,25.808-27.2,25.808c-15.032,0-27.216-11.544-27.216-25.808 s12.184-19.36,27.216-19.36C222.483,141.984,234.667,147.088,234.667,161.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M207.467,191.144c-17.208,0-31.216-13.368-31.216-29.808c0-14.84,11.376-23.36,31.216-23.36 c19.832,0,31.2,8.512,31.2,23.36C238.667,177.776,224.667,191.144,207.467,191.144z M207.467,145.984 c-15.408,0-23.216,5.168-23.216,15.36c0,12.024,10.416,21.808,23.216,21.808s23.2-9.784,23.2-21.808 C230.667,151.152,222.867,145.984,207.467,145.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M175.475,166.944h-8c-2.208,0-4-1.792-4-4s1.792-4,4-4h8c2.208,0,4,1.792,4,4 S177.683,166.944,175.475,166.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A4554"
    },
    d: "M260.267,161.344c0,14.256,12.184,25.808,27.216,25.808s27.216-11.544,27.216-25.808 s-12.184-19.36-27.216-19.36S260.267,147.088,260.267,161.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M287.483,191.144c-17.208,0-31.216-13.368-31.216-29.808c0-14.84,11.376-23.36,31.216-23.36 s31.216,8.512,31.216,23.36C318.699,177.776,304.691,191.144,287.483,191.144z M287.483,145.984 c-15.408,0-23.216,5.168-23.216,15.36c0,12.024,10.416,21.808,23.216,21.808s23.216-9.784,23.216-21.808 C310.699,151.152,302.891,145.984,287.483,145.984z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M327.475,166.944h-8c-2.208,0-4-1.792-4-4s1.792-4,4-4h8c2.208,0,4,1.792,4,4 S329.683,166.944,327.475,166.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M261.235,171.184c-2.208,0-4-1.792-4-4c0-5.376-4.392-9.76-9.784-9.76 c-5.368,0-9.736,4.376-9.736,9.76c0,2.208-1.792,4-4,4s-4-1.792-4-4c0-9.792,7.952-17.76,17.736-17.76 c9.808,0,17.784,7.968,17.784,17.76C265.235,169.4,263.443,171.184,261.235,171.184z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F6899"
    },
    d: "M351.083,78.48c0,30.8-50.816,26.352-103.608,26.352c-52.816,0-103.608,4.448-103.608-26.352 c0-30.808,50.8-78.48,103.608-78.48C300.275,0.008,351.083,47.68,351.083,78.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#125389"
    },
    d: "M247.475,0.008c52.8,0,103.608,47.672,103.608,78.48c0,30.8-50.816,26.352-103.608,26.352 c-52.816,0-103.608,4.448-103.608-26.352"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064672"
    },
    d: "M247.475,0.008c52.8,0,103.608,47.672,103.608,78.48c0,30.8-50.816,26.352-103.608,26.352"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B4F6D"
    },
    d: "M336.467,99.776c0,5.168-39.832,17.696-88.992,17.696c-49.168,0-89.008-12.52-89.008-17.696 s39.84-9.368,89.008-9.368C296.635,90.416,336.467,94.608,336.467,99.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#063B59"
    },
    d: "M247.475,90.416c49.16,0,88.992,4.192,88.992,9.368s-39.832,17.688-88.992,17.688"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5B342"
    },
    points: "247.475,30.128 254.747,44.88 271.011,47.24 259.251,58.728 262.027,74.928 247.475,67.272  232.923,74.928 235.699,58.728 223.939,47.24 240.187,44.88 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E29A44"
    },
    points: "247.475,30.128 254.747,52.88 271.011,47.24 259.251,58.728 262.027,74.928 247.475,67.272  232.923,74.928 235.699,58.728 223.939,47.24 240.187,52.88 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.956,
    y: 338.311,
    transform: "matrix(-0.9414 0.3374 -0.3374 -0.9414 291.2848 649.9922)",
    style: {
      fill: "#073D5B"
    },
    width: 82.411,
    height: 23.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.404,
    y: 346.691,
    transform: "matrix(-0.9413 0.3375 -0.3375 -0.9413 295.505 657.3507)",
    style: {
      fill: "#042635"
    },
    width: 82.414,
    height: 15.344
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.139,
    y: 338.309,
    transform: "matrix(-0.9423 0.3349 -0.3349 -0.9423 290.4731 650.5199)",
    style: {
      fill: "#E5B342"
    },
    width: 10.032,
    height: 23.985
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.863,
    y: 343.834,
    transform: "matrix(-0.9421 0.3353 -0.3353 -0.9421 262.7763 666.2925)",
    style: {
      fill: "#E5B342"
    },
    width: 10.016,
    height: 23.992
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.937,
    y: 343.103,
    transform: "matrix(-0.942 0.3355 -0.3355 -0.942 292.9987 654.6179)",
    style: {
      fill: "#D19315"
    },
    width: 10.032,
    height: 19.031
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D19315"
    },
    points: "82.659,365.424 73.227,368.776 66.787,350.872 76.227,347.496  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 364.585,
    y: 338.293,
    transform: "matrix(0.9414 0.3374 -0.3374 0.9414 141.9763 -116.3683)",
    style: {
      fill: "#073D5B"
    },
    width: 82.403,
    height: 23.993
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.164,
    y: 346.698,
    transform: "matrix(0.9413 0.3375 -0.3375 0.9413 143.3311 -115.6835)",
    style: {
      fill: "#042635"
    },
    width: 82.406,
    height: 15.352
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 400.743,
    y: 338.341,
    transform: "matrix(0.9421 0.3353 -0.3353 0.9421 140.9582 -115.7689)",
    style: {
      fill: "#E5B342"
    },
    width: 10.016,
    height: 23.992
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.069,
    y: 343.78,
    transform: "matrix(0.9422 0.3351 -0.3351 0.9422 143.5623 -120.5329)",
    style: {
      fill: "#E5B342"
    },
    width: 10.024,
    height: 23.984
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 399.92,
    y: 343.229,
    transform: "matrix(0.9419 0.336 -0.336 0.9419 142.0737 -115.5546)",
    style: {
      fill: "#D19315"
    },
    width: 10.023,
    height: 19.031
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.226,
    y: 348.663,
    transform: "matrix(0.9422 0.3351 -0.3351 0.9422 144.3186 -120.1113)",
    style: {
      fill: "#D19315"
    },
    width: 10.024,
    height: 19.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064672"
    },
    d: "M186.251,446.48c0,1.656-1.344,3-3,3H87.907c-1.656,0-3-1.344-3-3l0,0c0-1.656,1.344-3,3-3h95.344 C184.907,443.48,186.251,444.824,186.251,446.48L186.251,446.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064672"
    },
    d: "M412.251,446.48c0,1.656-1.344,3-3,3h-95.344c-1.656,0-3-1.344-3-3l0,0c0-1.656,1.344-3,3-3h95.344 C410.907,443.48,412.251,444.824,412.251,446.48L412.251,446.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064672"
    },
    d: "M186.251,462.48c0,1.656-1.344,3-3,3H87.907c-1.656,0-3-1.344-3-3l0,0c0-1.656,1.344-3,3-3h95.344 C184.907,459.48,186.251,460.824,186.251,462.48L186.251,462.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064672"
    },
    d: "M412.251,462.48c0,1.656-1.344,3-3,3h-95.344c-1.656,0-3-1.344-3-3l0,0c0-1.656,1.344-3,3-3h95.344 C410.907,459.48,412.251,460.824,412.251,462.48L412.251,462.48z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5B342"
    },
    points: "360.579,409.352 365.387,419.096 376.123,420.648 368.339,428.232 370.187,438.928  360.579,433.872 350.971,438.928 352.803,428.232 345.027,420.648 355.763,419.096 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E29A44"
    },
    points: "360.579,409.352 365.387,424.376 376.123,420.648 368.339,428.232 370.187,438.928  360.579,433.872 350.971,438.928 352.803,428.232 345.027,420.648 355.763,424.376 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.267,
    y: 293.728,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 579.63 422.3157)",
    style: {
      fill: "#2EA5C6"
    },
    width: 52.167,
    height: 74.951
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2680B2"
    },
    points: "247.299,339.224 210.403,376.112 157.403,323.112 207.595,299.544  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.482,
    y: 293.728,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 319.8871 -109.8678)",
    style: {
      fill: "#2680B2"
    },
    width: 52.167,
    height: 74.951
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicewoman);
export default __webpack_public_path__ + "static/media/policewoman.f728255f86df32c56c93f56f4b629965.svg";
export { ForwardRef as ReactComponent };